import { useCallback, useMemo } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';

const defaultConversationToggleConditions = {
  conversationPageActive: true,
  textareaBlur: true,
  stickerHide: true,
  activePhraseHide: true,
  passivePhraseHide: true,
  messageEditorEmpty: true,
};

const conversationToggleConditionsState = atom(defaultConversationToggleConditions);

const conversationToggleState = atom((get) => {
  return Object.values(get(conversationToggleConditionsState)).every((condition) => condition);
});

export const useConversationToggle = () => useAtomValue(conversationToggleState);

export const useSetConversationToggle = (
  conditionKey: keyof typeof defaultConversationToggleConditions,
) => {
  const setConditions = useSetAtom(conversationToggleConditionsState);
  return useCallback(
    (valueOrUpdater: boolean | ((pre: boolean) => boolean)) => {
      setConditions((pre) => {
        return {
          ...pre,
          [conditionKey]:
            typeof valueOrUpdater === 'function'
              ? valueOrUpdater(pre[conditionKey])
              : valueOrUpdater,
        };
      });
    },
    [conditionKey, setConditions],
  );
};

export const useConversationToggleTextareaProps = () => {
  const setConversationToggle = useSetConversationToggle('textareaBlur');

  return useMemo(
    () => ({
      onFocus: () => setConversationToggle(false),
      onBlur: () => setConversationToggle(true),
    }),
    [setConversationToggle],
  );
};
